import { createPath, type To } from "react-router-dom";

export type NavigationIntent = "push" | "start" | "finish";

export const navigationState = (intent: NavigationIntent) => ({ navigationIntent: intent });

export function getNavigationIntent(state: unknown): NavigationIntent | undefined {
  if (!state || typeof state !== "object" || !("navigationIntent" in state)) return;
  const intent = state.navigationIntent;
  return intent === "push" || intent === "start" || intent === "finish" ? intent : undefined;
}

export function workspaceHome(pathname: string): string | undefined {
  return pathname === "/" || /^\/b\/[^/]+\/forms\/(?:new|[^/]+(?:\/edit)?)\/?$/.test(pathname) ? "/" : undefined;
}

export function formPath(businessId: string, formId?: string): string {
  const path = `/b/${encodeURIComponent(businessId)}/forms`;
  return formId ? `${path}/${encodeURIComponent(formId)}` : path;
}

export function isSectionRoot(pathname: string): boolean {
  return pathname === "/";
}

export function isFormStep(path: string): boolean {
  const pathname = path.split(/[?#]/, 1)[0];
  return pathname === "/login" || /^\/b\/[^/]+\/forms\/(?:new|[^/]+\/edit)\/?$/.test(pathname);
}

export function navigationPath(to: To): string {
  return typeof to === "string" ? to : createPath(to);
}
